module.exports = __webpack_public_path__ + "assets/redpacket-limit-bg-5be959cc.png";